var map = {
	"./date-format.de-CH.json": 955,
	"./date-format.de-DE.json": 956,
	"./date-format.en-CA.json": 957,
	"./date-format.en-GB.json": 958,
	"./date-format.en-IN.json": 959,
	"./date-format.en-ME.json": 960,
	"./date-format.en-US.json": 961,
	"./date-format.es-EM.json": 962,
	"./date-format.es-ES.json": 963,
	"./date-format.fr-BE.json": 964,
	"./date-format.fr-CA.json": 965,
	"./date-format.fr-CH.json": 966,
	"./date-format.nl-BE.json": 967,
	"./date-format.nl-NL.json": 968,
	"./date-format.pl-PL.json": 969,
	"./date-format.pt-BR.json": 970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 954;